import { UntypedFormGroup } from "@angular/forms";
import { DocumentUploadRequest } from "./document-upload-request";

export class DocumentUploadMapper {

    public static mapClaimRequest(form: UntypedFormGroup): DocumentUploadRequest {
        if (form) {
            const claimForm = form.value;
            const claimRequest: DocumentUploadRequest = new DocumentUploadRequest();
            
            claimRequest.contractNumber = claimForm.contractNumber.toString().toUpperCase();
            claimRequest.claimNumber = claimForm.claimNumber;
            claimRequest.firstName = claimForm.customerFirstName;
            claimRequest.lastName = claimForm.customerLastName;
            claimRequest.email  = claimForm.emailAddress;
            claimRequest.phoneNumber = claimForm.phoneNumber;
            claimRequest.userType = claimForm.userType;
            claimRequest.message = claimForm.message;            

            return claimRequest;
        }
        else {
            return null;
        }
    }
}